import { motion } from 'framer-motion';

export function MotionDiv({ className, children, delay, ...rest }: any) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: delay ?? 0.15 }}
      viewport={{ once: true, amount: 0.2 }}
      className={`${className}`}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
